import React from 'react';

const About = () => {
  return (
    <div className="container mx-auto px-4 py-20">
      <div className="flex flex-col items-center gap-16 lg:flex-row">
        {/* Interactive code visual section */}
        <div className="relative w-full max-w-md lg:w-1/2">
          <div className="relative">
            {/* Custom border gradient */}
            <div className="absolute -inset-0.5 rounded-2xl bg-gradient-to-r from-cyan-500 to-blue-500 opacity-30 blur-sm"></div>
            <div className="relative overflow-hidden rounded-2xl border border-slate-800 bg-gradient-to-b from-slate-950 to-slate-900">
              <div className="aspect-[4/5] overflow-hidden">
                <div className="absolute -left-16 -top-16 h-64 w-64 rounded-full bg-gradient-to-br from-cyan-500/20 to-transparent blur-2xl"></div>
                <div className="absolute -bottom-16 -right-16 h-64 w-64 rounded-full bg-gradient-to-br from-blue-500/20 to-transparent blur-2xl"></div>
                
                {/* Business Growth Visualization */}
                <div className="flex h-full w-full flex-col items-center justify-center p-8">
                  {/* Digital presence elements */}
                  <div className="w-full space-y-6">
                    {/* Website Growth */}
                    <div className="rounded-lg border border-slate-700 bg-slate-800/50 p-4">
                      <div className="mb-2 flex items-center">
                        <svg className="mr-2 h-5 w-5 text-cyan-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
                        </svg>
                        <span className="font-medium text-white">Website Traffic</span>
                      </div>
                      <div className="h-3 w-full overflow-hidden rounded-full bg-slate-700">
                        <div className="h-full w-3/4 animate-pulse rounded-full bg-gradient-to-r from-cyan-400 to-blue-500"></div>
                      </div>
                      <div className="mt-1 flex justify-between text-xs text-slate-400">
                        <span>Previous</span>
                        <span className="text-cyan-400">+175% Growth</span>
                      </div>
                    </div>
                    
                    {/* Customer Conversion */}
                    <div className="rounded-lg border border-slate-700 bg-slate-800/50 p-4">
                      <div className="mb-2 flex items-center">
                        <svg className="mr-2 h-5 w-5 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                        <span className="font-medium text-white">Customer Conversion</span>
                      </div>
                      <div className="h-3 w-full overflow-hidden rounded-full bg-slate-700">
                        <div className="h-full w-2/3 animate-pulse rounded-full bg-gradient-to-r from-blue-400 to-purple-500"></div>
                      </div>
                      <div className="mt-1 flex justify-between text-xs text-slate-400">
                        <span>Industry Average</span>
                        <span className="text-blue-400">+40% Higher</span>
                      </div>
                    </div>
                    
                    {/* Search Rankings */}
                    <div className="rounded-lg border border-slate-700 bg-slate-800/50 p-4">
                      <div className="mb-2 flex items-center">
                        <svg className="mr-2 h-5 w-5 text-cyan-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <span className="font-medium text-white">Search Rankings</span>
                      </div>
                      <div className="flex items-end space-x-1">
                        <div className="h-4 w-2 animate-pulse bg-cyan-500/30"></div>
                        <div className="h-6 w-2 animate-pulse bg-cyan-500/50"></div>
                        <div className="h-8 w-2 animate-pulse bg-cyan-500/70"></div>
                        <div className="h-12 w-2 animate-pulse bg-cyan-500"></div>
                        <div className="h-16 w-2 animate-pulse bg-blue-500"></div>
                        <div className="h-10 w-2 animate-pulse bg-blue-500/70"></div>
                        <div className="h-14 w-2 animate-pulse bg-blue-500/90"></div>
                      </div>
                      <div className="mt-1 text-right text-xs text-slate-400">
                        <span className="text-cyan-400">Improved Page Rankings</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Experience card moved to float at bottom right */}
          <div className="absolute -bottom-6 -right-6 rounded-xl border border-slate-800 bg-slate-900 p-4 shadow-xl">
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-r from-cyan-500/20 to-blue-500/20 text-white">
                <span className="text-xl font-bold text-cyan-500">3+</span>
              </div>
              <div>
                <div className="text-sm font-medium text-white">Years of Experience</div>
                <div className="text-xs text-slate-400">in Web Development</div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Content section */}
        <div className="w-full lg:w-1/2">
          <div className="relative mb-8 inline-block">
            <div className="absolute -z-10 h-full w-full -rotate-2 rounded bg-gradient-to-r from-cyan-500 to-blue-500 blur-sm"></div>
            <span className="relative inline-block rounded bg-gradient-to-r from-cyan-500 to-blue-500 px-4 py-2 text-base md:text-lg font-bold uppercase tracking-wider text-white">
              About Me
            </span>
          </div>
          
          <h2 className="mb-6 text-4xl font-bold text-white md:text-5xl">
            I help brands <span className="bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent">scale</span> through effective web presence
          </h2>
          
          <div className="mb-8 space-y-4 text-slate-400">
            <p>
              I'm a professional web developer specializing in helping businesses enhance their online presence through custom website solutions. My approach combines aesthetic design with functional development to create websites that not only look great but also perform effectively as powerful business tools.
            </p>
            <p>
              I focus on creating compelling experiences that boost your conversion rates and transform visitors into customers. I optimize every aspect of your online presence for both user experience and search engine visibility to ensure your business stands out from the competition.
            </p>
            <p>
            I design everything with growth in mind, making sure your online presence can easily scale as your business grows without expensive rebuilds or major redesigns.
            </p>
          </div>
          
          {/* Stats */}
          <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
            <div className="text-center">
              <div className="text-3xl font-bold text-white">5+</div>
              <div className="text-sm text-slate-500">Happy Clients</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white">10+</div>
              <div className="text-sm text-slate-500">Projects</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white">40%</div>
              <div className="text-sm text-slate-500">Avg. Conversion Increase</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white">24/7</div>
              <div className="text-sm text-slate-500">Support</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
